import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useI18n} from '../../../common/providers/I18nProvider';
import {routes} from '../../../routing/routes';
import {useAuth} from '../../auth';

export default function Header() {
	const {i18n} = useI18n();
	const {currentUser} = useAuth();

	useEffect(() => {
		localStorage.setItem('currentStep', '1');
	}, []);

	return (
		<div className='flex justify-between sm:bg-white sm:p-6 sm:rounded-lg'>
			<div className='text-black text-lg md:text-xl font-bold py-2 mt-2'>
				<h3>{currentUser?.enterpriser?.stores?.at(0)?.storeName}</h3>
			</div>

			<div className='mt-4'>
				<Link
					to={routes.campaign.create}
					className='w-full rounded-full bg-primary text-white text-xs leading-5 sm:text-base sm:leading-6 font-medium h-10 py-3 sm:py-3.5 px-4 shadow-primary '
				>
					<FontAwesomeIcon icon={faPlus} />
					<span className='ml-3 font-medium'>{i18n('DASHBOARD.HEADER.CTA.NEW_CAMPAIGN')}</span>
				</Link>
			</div>
		</div>
	);
}
